<div *ngIf="loading$ | async as message" class="spinner">
	<p class="spinner__message">{{ message }}</p>
</div>
